import createEditSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideCreateEdit/lan/es';
import listSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideList/lan/es';
import deleteSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideDelete/lan/es';

export default {
    ...createEditSpeedOverride,
    ...listSpeedOverride,
    ...deleteSpeedOverride
};